import hashSum from "hash-sum";

// calculate object hashes to check difference between objects
export function isEqual(newVal, oldVal) {
  const newHash = hashSum(JSON.stringify(newVal));
  const oldHash = hashSum(JSON.stringify(oldVal));
  return newHash === oldHash;
}
